import { useParams } from 'react-router';

import { useGetBySimulationId } from 'src/api/simulations';

// ----------------------------------------------------------------------

export const useSimulationName = () => {
  const { simulation_id } = useParams();
  const { simulations, simulationsLoading } = useGetBySimulationId(simulation_id, 'name');
  if (simulationsLoading) return '...';
  return simulations[0]?.name || '';
};

// ----------------------------------------------------------------------

const SimulationName = () => useSimulationName();

SimulationName.propTypes = {};

export default SimulationName;
